import axios from "axios";

export const validateActivationCode = (activationCode) => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/${process.env.VUE_APP_APIVER}/utility/activationcode`,
    {
      activation_code: activationCode,
    }
  );
};
